import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileRepository from "../../../repository/ProfileRepository";
import { __remove, __set } from "../../axios_indicator";
import Constants from "src/helper/Constants";
const { shippingCarrierType: { MANUAL, AVNET } } = Constants

export const getProfileAccountInformation = createAsyncThunk('profile_getProfileAccountInformation', async () => {
    return await new ProfileRepository().getProfileAccountInformation()
});

export const getCountryList = createAsyncThunk('get_country_list', async () => {
    __set('PROFILE_ADDRESS_LIST');
    return await new ProfileRepository().getCountryList()
});

export const getJobFunctionList = createAsyncThunk('get_job_function_list', async () => {
    __set('PROFILE_JOB_FUNCTION_LIST');
    return await new ProfileRepository().getJobFunctionList()
});

export const fetchAllCarrierData = createAsyncThunk('fetch_all_carrier_data', async (params) => {
    return await Promise.all([
        new ProfileRepository().fetchCarrierData({ shippingCarrierType: MANUAL, ...params }),
        new ProfileRepository().fetchCarrierData({ shippingCarrierType: AVNET, ...params }),
    ]);
});

const initialState = {
    accountInformation: {},
    countryList: [],
    userInformation: {},
    jobFunctionList: [],
    allCarriers: [],
};
const slice = createSlice({
    name: "Profile",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [getProfileAccountInformation.fulfilled]: (state, { payload }) => {
            state.accountInformation = payload.data.accountInformation
            state.userInformation = payload.data.accountInformation?.user
            return state;
        },
        [getProfileAccountInformation.rejected]: (state, { payload }) => {
        },
        [getCountryList.fulfilled]: (state, { payload }) => {
            __remove('PROFILE_ADDRESS_LIST');
            state.countryList = payload;
        },
        [getJobFunctionList.fulfilled]: (state, { payload }) => {
            __remove('PROFILE_JOB_FUNCTION_LIST');
            state.jobFunctionList = payload;
        },
        [fetchAllCarrierData.fulfilled]: (state, { payload }) => {
            const [manualData, avnetData] = payload
            const combinedData = {
                ...manualData,
                fedEx: [...(manualData.fedEx || []), ...(avnetData.fedEx || [])],
                dhl: [...(manualData.dhl || []), ...(avnetData.dhl || [])],
                ups: [...(manualData.ups || []), ...(avnetData.ups || [])],
                dom: [...(manualData.dom || []), ...(avnetData.dom || [])],
                intl: [...(manualData.intl || []), ...(avnetData.intl || [])],
            };
            state.allCarriers = combinedData;
        },
    },
});

export let { setAllCarrierData } = slice.actions;

export default slice.reducer;
